import imageOne from '@/assets/images/cities/burnaby1.jpg'
import imageTwo from '@/assets/images/cities/burnaby2.jpg'
import imageThree from '@/assets/images/cities/burnaby3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Burnaby',
  writeup: '',
  website: 'MyBurnabyNotaryPublic.com',
  url: 'https://www.myburnabynotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '(604) 343-1010',
      hours: {
        monday: '4:00PM to 6:00PM',
        tuesday: '4:00PM to 6:00PM',
        wednesday: '4:00PM to 6:00PM',
        thursday: '4:00PM to 6:00PM',
        friday: '4:00PM to 6:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: '5481 Kingsway Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/britishColumbia/cities/burnaby.js